export default __webpack_public_path__ + "static/media/nft-ens.524c02ee.svg";